/* @flow */

export const WAIT_FOR_LONGPRESS_MS = 350;

export const EDGE_DRAG_SCROLL_THRESHOLD = 200;

export const SCROLL_EVENT_THROTTLE = 16;

export const SNAPTO_ANIMATION_DURATION = 300;

export const DISTANCE_TO_DECIDE_RESPONDER = 30;

export default {
  DISTANCE_TO_DECIDE_RESPONDER,
  EDGE_DRAG_SCROLL_THRESHOLD,
  SCROLL_EVENT_THROTTLE,
  SNAPTO_ANIMATION_DURATION,
  WAIT_FOR_LONGPRESS_MS,
};
